import type { StateCreator } from 'zustand';

import type { FilesSlice } from './types';

export type { FilesSlice } from './types';

export const filesInitialState: Pick<
  FilesSlice,
  | 'contentFiles'
  | 'isFilesLoading'
  | 'pendingLightboxFileId'
  | 'isResultMode'
  | 'generationsRefreshKey'
> = {
  contentFiles: [],
  isFilesLoading: false,
  pendingLightboxFileId: null,
  isResultMode: false,
  generationsRefreshKey: 0,
};

export const createFilesSlice: StateCreator<FilesSlice, [], [], FilesSlice> = (
  set
) => ({
  ...filesInitialState,

  setContentFiles: (contentFiles) => set({ contentFiles }),

  prependContentFile: (file) =>
    set((state) => {
      if (state.contentFiles.some((f) => f.uuid === file.uuid)) {
        return { contentFiles: state.contentFiles };
      }
      return { contentFiles: [file, ...state.contentFiles] };
    }),

  updateContentFile: ({ uuid, updates }) =>
    set((state) => ({
      contentFiles: state.contentFiles.map((file) =>
        file.uuid === uuid ? { ...file, ...updates } : file
      ),
    })),

  removeContentFiles: (uuids) =>
    set((state) => {
      const uuidSet = new Set(uuids);
      return {
        contentFiles: state.contentFiles.filter((f) => !uuidSet.has(f.uuid)),
      };
    }),

  setIsFilesLoading: (isFilesLoading) => set({ isFilesLoading }),

  setPendingLightboxFileId: (pendingLightboxFileId) =>
    set({ pendingLightboxFileId }),

  setIsResultMode: (isResultMode) => set({ isResultMode }),

  refreshGenerations: () =>
    set((state) => ({
      generationsRefreshKey: state.generationsRefreshKey + 1,
    })),
});
